document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-gw-home]').forEach((home) => {
    const slides = [...home.querySelectorAll('[data-slide]')];
    const current = home.querySelector('[data-current]');
    const dots = home.querySelector('[data-dots]');
    let index = 0;

    const show = (next) => {
      if (!slides.length) return;
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      if (current) current.textContent = String(index + 1).padStart(2, '0');
      if (dots) [...dots.children].forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };

    if (dots) slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', `Show arrival ${i + 1}`);
      dot.addEventListener('click', () => show(i));
      dots.append(dot);
    });
    home.querySelector('[data-prev]')?.addEventListener('click', () => show(index - 1));
    home.querySelector('[data-next]')?.addEventListener('click', () => show(index + 1));
    show(0);

    const rail = home.querySelector('[data-product-rail]');
    const scrollRail = (direction) => rail?.scrollBy({ left: direction * Math.min(rail.clientWidth * 0.82, 520), behavior: 'smooth' });
    home.querySelector('[data-rail-prev]')?.addEventListener('click', () => scrollRail(-1));
    home.querySelector('[data-rail-next]')?.addEventListener('click', () => scrollRail(1));
  });

  document.querySelectorAll('.gw-menu-button').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = document.getElementById(button.getAttribute('aria-controls'));
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      if (menu) menu.hidden = open;
    });
  });

  document.querySelectorAll('[data-collection-sort]').forEach((select) => {
    select.addEventListener('change', () => select.form?.requestSubmit());
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const panels = [...gallery.querySelectorAll('[data-media-panel]')];
    const thumbs = [...gallery.querySelectorAll('[data-media-thumb]')];
    const current = gallery.querySelector('[data-gallery-current]');

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
      const id = thumb.dataset.mediaThumb;
      panels.forEach((panel) => {
        const active = panel.dataset.mediaPanel === id;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      thumbs.forEach((item) => {
        const active = item === thumb;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (current) current.textContent = String(thumb.dataset.mediaIndex || 1).padStart(2, '0');
    }));
  });

  document.querySelectorAll('[data-gw-product]').forEach((product) => {
    const variant = product.querySelector('[data-product-variant]');
    const price = product.querySelector('[data-product-price] strong');
    const compare = product.querySelector('[data-product-price] s');
    const stock = product.querySelector('[data-product-stock]');
    const stockLabel = product.querySelector('[data-stock-label]');
    const availabilityLabel = product.querySelector('[data-availability-label]');
    const badge = product.querySelector('[data-product-badge]');
    const preorderNotice = product.querySelector('[data-preorder-notice]');
    const preorderDispatch = product.querySelector('[data-preorder-dispatch]');
    const preorderNote = product.querySelector('[data-preorder-note]');
    const preorderProperty = product.querySelector('[data-preorder-property]');
    const preorderDispatchProperty = product.querySelector('[data-preorder-dispatch-property]');
    const preorderNoteProperty = product.querySelector('[data-preorder-note-property]');
    const submit = product.querySelector('[data-product-submit]');
    const submitLabel = product.querySelector('[data-submit-label]');
    const submitPrice = product.querySelector('[data-submit-price]');
    if (!variant) return;

    variant.addEventListener('change', () => {
      const option = variant.selectedOptions[0];
      const available = option?.dataset.available === 'true';
      const preorder = option?.dataset.preorder === 'true';
      const dispatch = option?.dataset.dispatch || '';
      const note = option?.dataset.preorderNote || '';
      const stateLabel = preorder ? (available ? 'PRE-ORDER' : 'PRE-ORDER CLOSED') : (available ? 'IN STOCK' : 'SOLD OUT');
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
      if (compare) {
        compare.textContent = option?.dataset.compare || '';
        compare.hidden = !option?.dataset.compare;
      }
      if (submit) submit.disabled = !available;
      if (submitLabel) submitLabel.textContent = preorder ? (available ? 'PRE-ORDER' : 'PRE-ORDER CLOSED') : (available ? 'ADD TO PIT BAG' : 'SOLD OUT');
      if (submitPrice && option?.dataset.price) submitPrice.textContent = option.dataset.price;
      if (stock) {
        stock.classList.toggle('is-sold-out', !available);
        stock.classList.toggle('is-preorder', preorder);
      }
      if (stockLabel) stockLabel.textContent = stateLabel;
      if (availabilityLabel) availabilityLabel.textContent = stateLabel;
      if (badge) badge.textContent = preorder ? 'PRE-ORDER' : (badge.dataset.defaultBadge || 'PACK PICK');
      if (preorderNotice) preorderNotice.hidden = !preorder;
      if (preorderDispatch) preorderDispatch.textContent = dispatch ? `Expected dispatch: ${dispatch}.` : 'The dispatch window is being confirmed.';
      if (preorderNote) {
        preorderNote.textContent = note;
        preorderNote.hidden = !note;
      }
      if (preorderProperty) preorderProperty.disabled = !preorder;
      if (preorderDispatchProperty) {
        preorderDispatchProperty.value = dispatch;
        preorderDispatchProperty.disabled = !preorder || !dispatch;
      }
      if (preorderNoteProperty) {
        preorderNoteProperty.value = note;
        preorderNoteProperty.disabled = !preorder || !note;
      }
      if (option?.dataset.variantUrl) window.history.replaceState({}, '', option.dataset.variantUrl);
      if (option?.dataset.media) product.querySelector(`[data-media-thumb="${option.dataset.media}"]`)?.click();
    });
  });
});
